import React from "react";

interface GpuCountLabelProps {
  count: string;
}

function GpuCountLabel({ count }: GpuCountLabelProps) {
  const gpuCountParsed = parseInt(count.replace("x", ""));
  const gpuCount = Number.isNaN(gpuCountParsed) ? 1 : gpuCountParsed;

  // Color scheme based on GPU count for visual differentiation
  const getColorClasses = () => {
    if (gpuCount === 1)
      return {
        bg: "bg-gray-100/10",
        border: "border-gray-200/40",
        text: "text-white",
        glow: "shadow-gray-100/10",
      };
    if (gpuCount === 2)
      return {
        bg: "bg-green-500/20",
        border: "border-green-500/60",
        text: "text-green-400",
        glow: "shadow-green-500/20",
      };
    if (gpuCount === 4)
      return {
        bg: "bg-yellow-500/20",
        border: "border-yellow-500/60",
        text: "text-yellow-400",
        glow: "shadow-yellow-500/20",
      };
    if (gpuCount >= 8)
      return {
        bg: "bg-purple-500/20",
        border: "border-purple-500/60",
        text: "text-purple-400",
        glow: "shadow-purple-500/20",
      };
    return {
      bg: "bg-gray-500/20",
      border: "border-gray-500/60",
      text: "text-gray-400",
      glow: "shadow-gray-500/20",
    };
  };

  const colors = getColorClasses();

  return (
    <div
      className={`min-w-[3rem] h-12 rounded-lg border-2 flex flex-col items-center justify-center p-2 ${colors.bg} ${colors.border} ${colors.text} shadow-lg ${colors.glow} transition-all duration-200 hover:scale-105`}
    >
      <div className="text-2xl font-bold leading-none">{gpuCount}</div>
      <div className="text-[8px] uppercase font-semibold opacity-75 tracking-wider leading-none">
        GPU{gpuCount > 1 ? "s" : ""}
      </div>
    </div>
  );
}

export default GpuCountLabel;
